import * as Yup from "yup";
import { cpfValidator } from "../../../utils/CpfValidator";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";

export const ExcluirContaValidation = Yup.object({
  cpf: Yup.string()
    .test("cpf-valid", "Verifique se o CPF está correto, com 11 dígitos", function (value) {
      const benef = getBenef();
      const cleanedCpf = value?.replace(/[-./]/g, '');
      const cleanedBenefCpf = benef?.cpf?.replace(/[-./]/g, '');
      return cpfValidator(value || "") && cleanedCpf === cleanedBenefCpf;
    })
    .required("Insira um CPF válido e correto"),
});
